import { request } from './request'

/**
 * 获取订单列表
 */
export async function fetchOrderList(pageNum = 1, pageSize = 10) {
  const res = await request.post('/api/order/list', { pageNum, pageSize })
  return res.data || {}
}

/**
 * 获取发票申请详情
 */
export async function fetchInvoiceApplyDetail(id) {
  const res = await request.post('/api/order/getInvoiceApplyDetail', { id })
  return res.data || {}
}

/**
 * 申请发票
 */
export async function applyInvoice(params) {
  const res = await request.post('/api/order/applyInvoice', params)
  return res
}

/**
 * 修改发票申请
 */
export async function updateInvoice(params) {
  const res = await request.post('/api/order/updateInvoice', params)
  return res
}

/**
 * 取消发票申请
 */
export async function cancelInvoiceApply(id) {
  const res = await request.post('/api/order/cancelInvoiceApply', { id })
  return res
}

/**
 * 微信统一下单（获取支付二维码链接）
 */
export async function wxUnifiedOrder(orderNo, type = 'web') {
  const res = await request.post('/api/order/wxUnifiedOrder', { orderNo, type })
  return res.data || {}
}

/**
 * 查询支付状态
 */
export async function getPayStatus(orderNo) {
  const res = await request.post('/api/order/getPayStatus', { orderNo })
  return res.data || {}
}
